export function formatAmount(
  amount: number | null | undefined,
  currency: string | null | undefined,
  locale: string
): string {
  if (amount == null) return '—';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency ?? 'EUR',
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount} ${currency ?? '€'}`;
  }
}
